import { MODULE_NAME } from "../moduleName";
import { User } from "../services/domain/User";
import { PagedResponse, UserAuth } from "@ofqual/portal-core/core/types";
import { CrudResult } from "./types";

export enum UsersStatus {
  notLoaded = "NOT_LOADED",
  loading = "LOADING",
  loaded = "LOADED",
}

export type UsersState = {
  response: PagedResponse<User>;
  status: UsersStatus;
  hasData: boolean;
};

export enum UserStatus {
  notLoaded = "NOT_LOADED",
  loading = "LOADING",
  loaded = "LOADED",
  updating = "UPDATING",
}

export type UserState = {
  user: User | null;
  status: UserStatus;
  lastCrudResult: CrudResult;
};

export enum CreateUserStatus {
  inputting = "INPUTTING",
  creating = "CREATING",
}

export type CreateUserState = {
  status: CreateUserStatus;
  lastCrudResult: CrudResult;
};

interface ModuleState {
  // other state areas for this module....
  users: UsersState;
  user: UserState;
  createUser: CreateUserState;
}

// if there is any state from other modules that we use in this module
//  we have an opportunity to at least type it for ourselves
interface RemoteState {
  auth: {
    user: UserAuth
  };
}

export interface GlobalState extends RemoteState {
  [MODULE_NAME]: ModuleState;
}
